exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-290cfc23]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.modal-close[data-v-290cfc23]{cursor:pointer}@media(max-width: 400px){.modal-content[data-v-290cfc23]{padding-left:20px;padding-right:20px}}", ""]);

// exports
